import { FunnelFlowConfig, quiz, screen } from 'funnel/src/app/flow/flow-config';

// Romance funnel v2 (Sep 2026): romance-only question set on top of the
// kindle base, entertainment first, no age/gender split.
export const romanceFunnelFlow: FunnelFlowConfig = {
  screens: [
    quiz('wishReadAloud'),

    quiz('romanceSubgenres'),

    quiz('amountInfo'),

    quiz('romanceBooksPerMonth'),
    quiz('romanceBookSource'),
    quiz('audioExperienceInfo'),

    quiz('romanceSpiceLevel'),

    quiz('romanceVoicePreference'),

    quiz('personType'),
    quiz('personTypeInfo'),

    quiz('romanceDiscovery'),

    quiz('kindleFriction'),
    quiz('romanceHonestInfo'),

    quiz('visionCare'),
    quiz('visionCareInfo', { skipIf: { step: 'visionCare', is: ['allGood'] } }),

    quiz('time'),

    quiz('audioCustomizationInfo'),
    screen('customization'),

    quiz('celeb1'),
    quiz('celeb2'),
    quiz('celeb3'),

    quiz('book1'),
    quiz('book2'),
    quiz('book3'),
    quiz('yourBook'),

    quiz('listeningTime'),

    quiz('prediction'),
    screen('ready'),
    screen('login'),

    quiz('result'),
    screen('paywall'),
  ],
};
